module.exports = __webpack_public_path__ + "img/hps to hem.9a77fce4.png";